<div class="size-full">
  @if (appComponentInitializing$ | async) {
    <app-loading-screen></app-loading-screen>
  }

  <router-outlet></router-outlet>
</div>
